import React from "react";
import {FaLinkedinIn, FaGithub, FaMailBulk,FaArrowUp} from 'react-icons/fa'
import './Home.css'

const Home=()=>{
  return (
    <div className="app-container">
      <div className="app-card-container">
        <nav className="nav-container">
          <div>
            <ul className="list-mini">
              <li className="pop-heading"><a className='anchor'  href="#Home">Home</a></li>
              <li className="pop-heading"><a className='anchor'  href="#About">About</a></li>
              <li className="pop-heading"><a className='anchor' href="#Education">Education</a></li>
              <li className="pop-heading"><a className='anchor' href="#Experience">Experience</a></li>
              <li className="pop-heading"><a className='anchor' href="#Skills/Certifications">Skills / Certifications</a></li>
              <li className="pop-heading"><a className='anchor' href="#Projects">Projects</a></li>
              <li className="pop-heading"><a className='anchor' href="#Contact">Contact</a></li>
            </ul>
          </div>
        </nav>
        <div id="Home">
          <div className="card-container">
            <div>
              <h1 className="heading">Hello !</h1>
              <h1 className="heading">I'm <br /><br /><span className="name">JAGADEESH UDUGUNDLA</span></h1>
              <p className="tag">A Full Stack Developer</p>
              <div className="buttons-container">
                <button className="button1"><a className='anchor1' href="https://docs.google.com/document/d/1Mwqcqn5DfsSFE3ppNRoLpgUmulHpVME7JWhQmQgeOfQ/edit?usp=sharing" target="_blank" rel="noopener noreferrer">Resume</a></button>
                <button className="button"><a className='anchor' href="#Contact">Contact Me</a></button>
              </div>
            </div>
            <img src="https://res.cloudinary.com/dyrxlfj1o/image/upload/v1688223877/newprofile_edepuy.png" className="image" style={{borderRadius:"200px"}} alt="profile"/>
          </div>
        </div>
        <div id="About">
          <div className="about-container">
            <h1 className="about-heading">About</h1>
            <div className="about">
              <p className="about">I completed graduation in <span className="tag">BSC Computer Science</span> from SRI KRISHNADEVARAYA UNIVERSITY in 2018
                  the stream of Mathematics, Statistics, Computer Science. 
                  <br />
                  <br />
                  After my graduation I took an Intencive course on <span className="tag">PYTHON FULLSTACK DEVELOPER</span> at NXTWAVE. 
                  <br />
                  <br />
                  After 5 months of course duration I got a job at eClerx Company. My designation is <span className="tag">Senior Analyst</span>.
                  My role is <span className="tag">Backend Developer</span> and <span className="tag">Manual Testing</span>. Where I used Technologies are Python, NodeJs, MongoDB and JavaScript
                  <br />
                  <br />
                  My Hobbies are playing Cricket, Carroms and Browsing internet.
                  <br />
                  <br />
              </p>
            </div>
          </div>
        </div>
        <div id="Education">
          <div className="about-container">
          <h1 className="about-heading">Education</h1>
            <div className="education">
              <p className="course">Full Stack Development sep 2021 - feb 2022</p>
              <p className="college">NXTWAVE</p>
            </div>
            <div className="education">
              <p className="course">BSC Computer Science - 2018</p>
              <p className="college">SRI KRISHNADEVARAYA UNIVERSITY, ANANTAPUR</p>
            </div>
            <div className="education">
              <p className="course">M.P.C - 2015</p>
              <p className="college">SAI CHAINTANYA JR COLLEGE, DHARMAVARAM</p>
            </div>
            <div className="education">
              <p className="course">10TH - 2013</p>
              <p className="college">GOVERNMENT HIGH SCHOOL, DHARMAVARAM</p>
            </div>
          </div>
        </div>
        <div id="Experience">
          <div className="about-container">
            <h1 className="about-heading">Experience</h1>
            <div className="education">
              <p className="tag">eClerx  (FEB-2022 TO NOV-2022)</p>
              <p className="college">PUNE, MAHARASTRA</p>
            </div>
              <p>I have 10 months of experience in eClerx. The designation is <span className="tag">SENIOR ANALYST</span>, My role is <span className="tag">Backend Developer</span> and <span className="tag">Manual Testing</span>.
                  Where is used technologies are Python, NodeJs, MongoDB, JavaScript.
                  <ul>
                    <li>Trained in SQL, Python, MongoDB, Node.js</li>
                    <li>Manual testing on UI and Reporting Bugs on UI</li>
                    <li>Worked on Postman for testing Purpose</li>
                    <li>Worked on importing excel sheet data into Robo 3T automatically in the Node.js project. UsedRobo 3T for querying databases in MongoDB</li>
                  </ul>
              </p>
          </div>
        </div>
        <div id="Skills/Certifications">
          <div className="about-container">
            <h1 className="about-heading">Skills / Certifications</h1>
              <div className="card-container">
                <button className="skills-card-container">
                  <p className="skill"><a className='anchor1' href="https://certificates.ccbp.in/intensive/static-website?id=FRBLYMPVRN" target="_blank" rel="noopener noreferrer">HTML, CSS, BOOTSTRAP</a></p>
                </button>
                <button className="skills-card-container">
                <p className="skill"><a className='anchor1' href="https://certificates.ccbp.in/intensive/dynamic-web-application?id=IWFDWRCKWZ" target="_blank" rel="noopener noreferrer" >JAVASCRIPT</a></p>
                </button>
                <button className="skills-card-container">
                <p className="skill"><a className='anchor1' href="https://certificates.ccbp.in/intensive/programming-foundations?id=VUNPYMVWJH" target="_blank" rel="noopener noreferrer">PYTHON</a></p>
                </button>
                <button className="skills-card-container">
                <p className="skill"><a className='anchor1' href="https://certificates.ccbp.in/intensive/introduction-to-databases?id=XWKWRWLCEJ" target="_blank" rel="noopener noreferrer">SQL</a></p>
                </button>
                <button className="skills-card-container">
                <p className="skill"><a className='anchor1' href="https://certificates.ccbp.in/intensive/node-js?id=ZIHKRSYSCQ" target="_blank" rel="noopener noreferrer" >Node Js</a></p>
                </button>
                <button className="skills-card-container">
                <p className="skill"><a className='anchor1' href="https://certificates.ccbp.in/intensive/react-js?id=IQWLZMFLOL" target="_blank" rel="noopener noreferrer">REACT JS</a></p>
                </button>
                <button className="skills-card-container ">
                  <p className="skill">MANUAL TESTING</p>
                </button>
                <button className="skills-card-container ">
                <p className="skill"><a className='anchor1' href="https://certificates.ccbp.in/intensive/data-analytics-using-powerbi?id=FNVLYPXPFZ" target="_blank" rel="noopener noreferrer">POWER BI</a></p>
                </button>
                <button className="skills-card-container ">
                <p className="skill"><a className='anchor1' href="https://certificates.ccbp.in/intensive/data-analytics-using-tableau?id=QAEMVVUHKT" target="_blank" rel="noopener noreferrer">TABLEAU</a></p>
                </button>
                <button className="skills-card-container ">
                  <p className="skill"><a className='anchor1' href="https://certificates.ccbp.in/intensive/developer-foundations?id=SVEMODMVQV" target="_blank" rel="noopener noreferrer" >GIT</a></p>
                </button>
                <button className="skills-card-container ">
                  <p className="skill">SELENIUM AUTOMATION TESTING WITH PYTHON</p>
                </button>
              </div>
          </div>
        </div>
        <div id='Projects'>
              <div className='about-container'>
                <h1 className='about-heading'>My Projects</h1>
                  <div className='project-container'>
                    <div className="flip-box">
                      <div className="flip-box-inner">
                        <div className="flip-box-front">
                          <img src="https://res.cloudinary.com/dyrxlfj1o/image/upload/v1688233025/country_bemylk.png" className='flip-card-logo' alt="logo"/>
                          <p className='logo-tag'>Country Search</p>
                        </div>
                        <div className="flip-box-back">
                          <p className='back-details'>Country Search</p>
                          <button type="button" className='card-button'><a className='anchor' href="http://jagadeeshcs.ccbp.tech/" target="_blank" rel="noreferrer" >Site</a></button>
                          <button type="button" className='card-button1'><a className='anchor' href="https://github.com/JagadeeshUJ/country" target="_blank" rel="noopener noreferrer">Code</a></button>    
                        </div>
                      </div>
                    </div>
                    <div className="flip-box">
                      <div className="flip-box-inner">
                        <div className="flip-box-front">
                          <img src="https://res.cloudinary.com/dyrxlfj1o/image/upload/v1688269263/Wiki_jj6oko.png" className="flip-card-logo" alt="logo" />
                          <p className='logo-tag'>Wikipedia Search</p>
                        </div>
                        <div className="flip-box-back">
                        <p className='back-details1'>Wikipedia Search</p>
                          <button type="button" className='card-button'><a className='anchor' href="http://jagadeeshws.ccbp.tech/" target="_blank" rel="noopener noreferrer">Site</a></button>
                          <button type="button" className='card-button1'><a className='anchor' href="https://github.com/JagadeeshUJ/Wikipedia" target="_blank" rel="noopener noreferrer">Code</a></button>
                        </div>
                      </div>
                    </div>
                    <div className="flip-box">
                      <div className="flip-box-inner">
                        <div className="flip-box-front">
                          <img src="https://res.cloudinary.com/dyrxlfj1o/image/upload/v1688269422/emojigame_u20sun.png" className="flip-card-logo" alt="logo"/>
                          <p className='logo-tag'>Emoji Game</p>
                        </div>
                        <div className="flip-box-back">
                        <p className='back-details'>Emoji Game</p>
                          <button type="button" className='card-button'><a className='anchor' href="http://jagadeesheg.ccbp.tech/" target="_blank" rel="noopener noreferrer">Site</a></button>
                          <button type="button" className='card-button1'><a className='anchor' href="https://github.com/JagadeeshUJ/emoji" target="_blank" rel="noopener noreferrer">Code</a></button>
                        </div>
                      </div>
                    </div>
                    <div className="flip-box">
                      <div className="flip-box-inner">
                        <div className="flip-box-front">
                          <img src="https://res.cloudinary.com/dyrxlfj1o/image/upload/v1688269670/typingspeed_qrawxs.png" className="flip-card-logo" alt="logo"/>
                          <p className='logo-tag'>Typing Speed Tester</p>
                        </div>
                        <div className="flip-box-back">
                        <p className='back-details'>Typing speed tester</p>
                          <button type="button" className='card-button'><a className='anchor' href="https://test-speed-typing.netlify.app/" target="_blank" rel="noopener noreferrer">Site</a></button>
                          <button type="button" className='card-button1'><a className='anchor' href="https://github.com/Jagadeesh-Udugundla/typing" target="_blank" rel="noopener noreferrer">Code</a></button>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
        </div>
        <div id="Contact">
              <div className="about-container">
                <h1 className="about-heading">Contact Me</h1>
                <div className="" style={{marginTop:"5px"}}>
                  <h1 className='tag1'>This is my Mail id.<br/>Mail me <a href="mailto:jagadeeshu9951@gmail.com" target="_blank" rel="noopener noreferrer">jagadeeshu9951@gmail.com</a></h1>
                    <div className="contact-icons-container">
                      <button type="button" className="icon-button" testid="searchButton">
                        <a href="https://www.linkedin.com/in/jagadeesh-udugundla-b20949215/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn className="contact-icon" /></a>
                      </button>
                      <button type="button" className="icon-button" testid="searchButton">
                        <a href="https://github.com/Jagadeesh-Udugundla" target="_blank" rel="noopener noreferrer"><FaGithub className="contact-icon" /></a>
                      </button>
                      <button type="button" className="icon-button" testid="searchButton">
                        <a href="mailto:jagadeeshu9951@gmail.com" target="_blank" rel="noopener noreferrer"><FaMailBulk className="contact-icon" /></a>
                        
                      </button>
                  </div>
              </div>
              </div>
        </div>
        <div className="jj" style={{paddingLeft:"20px"}}>
        <a href="#Home"><FaArrowUp/></a>
        </div>
      </div>
    </div>
    )
  }

export default Home